<udex-tile
  [interactive]="(stepInputService.isStepInputDisabled$ | async) === null"
  (click)="udexEventTypeService.preventEventDefault($event); onAttributeChange()">
  <div class="tile">
    <udex-checkbox
      [id]="createAttributeValueIdForConfigurator(attribute, attribute?.values?.[0]?.valueCode ?? '')"
      [checked]="isAddOnChecked"
      [cxFocus]="{key: attribute.name + '-' + attribute?.values?.[0]?.name}"
      (change)="onAttributeChange()"
      (click)="$event.stopImmediatePropagation(); $event.stopPropagation(); $event.preventDefault()"
      [name]="createAttributeIdForConfigurator(attribute)"
      [accessibleName]="createAttributeIdForConfigurator(attribute)"
      [disabled]="(stepInputService.isStepInputDisabled$ | async) || readonly"></udex-checkbox>
    <div class="d-flex tile__content flex-column udex-pt-8 udex-mt-2">
      <label
        class="tile__content__heading body--s"
        [id]="createValueUiKey('label', attribute.name, attribute?.values?.[0]?.valueCode ?? '')"
        [for]="createAttributeValueIdForConfigurator(attribute, attribute?.values?.[0]?.valueCode ?? '')"
        >{{ attribute?.label }}
      </label>
      <label
        class="tile__content__description udex-pt-4 body--xs"
        *ngIf="attribute?.values?.[0]?.description"
        [innerHTML]="attribute?.values?.[0]?.description"></label>
      <ng-container *ngIf="isAddOnChecked" [ngTemplateOutlet]="subConfiguration"></ng-container>
    </div>
  </div>
</udex-tile>
<ng-template #subConfiguration>
  <label
    (click)="$event.preventDefault(); $event.stopPropagation(); $event.stopImmediatePropagation()"
    class="sub-config udex-pt-24">
    <div class="sub-config__heading">
      <ng-container
        class="d-flex"
        [cxConfiguratorAttributeComponent]="{
          componentKey: 'Header',
          attribute: alteredAttributeWithDifferentLabel,
          owner: attributeComponentContext.owner,
          group: attributeComponentContext.group,
          expMode: attributeComponentContext.expMode,
          language: (activeLanguage$ | async) ?? '',
          isNavigationToGroupEnabled: false,
        }"></ng-container>
    </div>
    <div class="sub-config__attribute">
      <ng-container
        class="d-flex"
        [cxConfiguratorAttributeComponent]="{
          componentKey: 'AttributeType_dropdown',
          attribute: attributeComponentContext.attribute,
          owner: attributeComponentContext.owner,
          group: attributeComponentContext.group,
          language: (activeLanguage$ | async) ?? '',
          expMode: attributeComponentContext.expMode,
          isNavigationToGroupEnabled: false,
        }"></ng-container>
    </div>
  </label>
  <label
    (click)="$event.preventDefault(); $event.stopPropagation(); $event.stopImmediatePropagation()"
    *ngFor="let addonAttribute of this.addonAttributes$ | async"
    class="sub-config udex-pt-24">
    <div class="sub-config__heading">
      <ng-container
        class="d-flex"
        [cxConfiguratorAttributeComponent]="{
          componentKey: 'Header',
          attribute: addonAttribute,
          owner: attributeComponentContext.owner,
          group: attributeComponentContext.group,
          expMode: attributeComponentContext.expMode,
          language: (activeLanguage$ | async) ?? '',
          isNavigationToGroupEnabled: false,
        }"></ng-container>
    </div>
    <div class="sub-config__attribute">
      <ng-container
        class="d-flex"
        [cxConfiguratorAttributeComponent]="{
          componentKey: getComponentKey(addonAttribute),
          attribute: addonAttribute,
          owner: attributeComponentContext.owner,
          group: attributeComponentContext.group,
          language: (activeLanguage$ | async) ?? '',
          expMode: attributeComponentContext.expMode,
          isNavigationToGroupEnabled: false,
        }"></ng-container>
    </div>
  </label>
</ng-template>
